import { Button, Col, Form, Radio, Row, Space } from "antd";
import { InputFields, Notification } from "components/common";
import fieldsAgree from "pages/CustomerService/ConsultantAndTreament/Detail/Modal/config";
import React, { useEffect, useState } from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import dayjs from "dayjs";
import { consultantAndFragmentService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  setCheckedRow,
  setDataCustomerCare,
  setDataLichSus,
  setIdCustomerCare,
  setIdDatLich,
} from "redux/reducer/customerCare";
const ModalAgree = (props) => {
  const [formAgree] = Form.useForm();
  const [field, setFields] = useState(fieldsAgree(FIELD_TYPE.DATE_ON));
  const { closeModal, getList, params } = props;
  const idDatLich = useAppSelector((e) => e.customerCare.idDatlichPT);
  const dispatch = useAppDispatch();

  //Đặt lại lịch hẹn
  const postSurgeryAgree = async () => {
    const value = formAgree.getFieldsValue();
    const newValue = {
      ...value,
      idPhieuTuVan: idDatLich,
      thoiGianHen: value.thoiGianHen
        ? dayjs(value.thoiGianHen).format(FORMAT_TIME.timeDetail)
        : null,
    };
    try {
      const onDate = new Date().getDate();
      const pickedDate = new Date(value.thoiGianHen).getDate();
      const validateParams1 = new Date(params.ngayHenPTTu).getDate();

      const validateParams2 = new Date(params.ngayHenPTDen).getDate();

      await consultantAndFragmentService.postSurgeryAgree(newValue);
      // if (
      //   onDate === pickedDate ||
      //   (params.ngayHenPTTu &&
      //     onDate === pickedDate &&
      //     onDate === validateParams1) ||
      //   (params.ngayHenPTDen &&
      //     onDate === validateParams2 &&
      //     onDate === pickedDate)
      // ) {
      // } else {
      dispatch(setIdCustomerCare(null));
      dispatch(setDataCustomerCare(null));
      dispatch(setDataLichSus(null));
      dispatch(setCheckedRow([]));
      dispatch(setIdDatLich(null));
      // }
      closeModal();
      getList();

      Notification("success", "Đặt lịch phẫu thuật thành công ");
    } catch (error) {
      Notification("error", "Đặt lịch phẫu thuật không thành thành công");
    }
  };

  useEffect(() => {
    formAgree.resetFields();
  }, [idDatLich]);

  return (
    <Row gutter={[16, 8]}>
      <Form form={formAgree} initialValues={{ thoiGianHen: dayjs() }}>
        <Row gutter={[16, 8]}>
          <Col xl={24} lg={24} xs={24}>
            <Form.Item
              label="Thời gian phẫu thuật"
              initialValue={0}
              name={"thoiGianPhauThuat"}
              wrapperCol={{ xs: 14, md: 16, lg: 16 }}
              labelCol={{ xs: 10, md: 8, lg: 8 }}
              labelAlign="left"
            >
              <Radio.Group>
                <Radio
                  value={0}
                  onChange={() => {
                    formAgree.setFieldsValue({
                      thoiGianHen: dayjs(),
                    });
                    setFields(fieldsAgree(FIELD_TYPE.DATE_ON));
                  }}
                >
                  Trong ngày
                </Radio>
                <Radio
                  value={1}
                  onChange={() => {
                    setFields(fieldsAgree(FIELD_TYPE.DATE_PRE));
                  }}
                >
                  Hẹn lịch
                </Radio>
                ;
              </Radio.Group>
            </Form.Item>
          </Col>
          <InputFields data={field} />
        </Row>
        <Row style={{ marginTop: "10px" }} justify={"end"}>
          <Space>
            <Button
              key="cancel"
              type="primary"
              danger
              onClick={() => closeModal()}
            >
              Huỷ bỏ
            </Button>

            <Button
              key="submit"
              type="primary"
              htmlType="submit"
              onClick={postSurgeryAgree}
            >
              Lưu lại
            </Button>
          </Space>
        </Row>
      </Form>
    </Row>
  );
};

export default ModalAgree;
